
 export const log = (type, ...props) => {

  const cl = localStorage.getItem('consoleLevel') || 1;
  if (type > cl) { return; }

  switch(type) {
    case 0:
    case 'error':

        if ( 0 <=  cl) { console.error(...props) }
        break;

    case 1:
    case 'warn':

        if ( 1 <= cl) { console.warn(...props) }
        break;

    default:

        if ( type <= cl) { console.log(...props) }
        break;

  }
}

